import { render, staticRenderFns } from "./OrderPdf.vue?vue&type=template&id=5730ba0b&"
import script from "./OrderPdf.vue?vue&type=script&lang=js&"
export * from "./OrderPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports